import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EdgeRouterServiceV2, HostService, NETWORK_SERVICE, NetworkControllerService, NetworkServiceV2 } from '@netfoundry-ui/shared/apiv2';
import { Environment, ENVIRONMENT, NetworkV2, EdgeRouterV2 } from '@netfoundry-ui/shared/model';
import { ApiService } from '@netfoundry-ui/shared/services';
import _ from 'lodash';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { PagedGetOption } from '@lagoshny/ngx-hateoas-client';
import semver from 'semver';

@Component({
    selector: 'app-network-info-v2',
    templateUrl: './network-info-v2.component.html',
    styleUrls: ['./network-info-v2.component.scss'],
    providers: [HostService],
    standalone: false
})
export class NetworkInfoV2Component implements OnInit {
    networkModel: NetworkV2 = new NetworkV2();
    items = [];

    majorVersionNumber;
    currentNetwork;
    networkControllersList = [];
    edgeRouters: EdgeRouterV2[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<NetworkInfoV2Component>,
        private apiService: ApiService,
        private edgeRouterService: EdgeRouterServiceV2,
        private networkControllerService: NetworkControllerService,
        @Inject(NETWORK_SERVICE) private networkServiceV2: NetworkServiceV2,
        private hostService: HostService,
        public growlerService: GrowlerService,
        @Inject(ENVIRONMENT) public environment: Environment
    ) {
        this.networkModel = data.network;
        this.majorVersionNumber = apiService.getNetworkVersion(this.networkModel);
    }

    ngOnInit(): void {

        this.networkControllerService.getNetworkControllerPage(this.getOptions()).then(
            (result) => {
                this.networkControllersList = result;
                this.items = [];
                    for (const controller of this.networkControllersList) {
                        // 🟢 Each controller gets new arrays
                        const controllerIps: string[] = [];
                        const controllerDomains: string[] = [];
                        const portStrings: string[] = [];

                        // Collect IP
                        if (controller.host?.ipAddress) {
                        controllerIps.push(controller.host.ipAddress);
                        }

                        // Determine port
                        let port = '443';
                        if (controller.softwareDeploymentState?.softwareConfigurationPortEnabled) {
                        port = `${port}/6262`;
                        }
                        portStrings.push(port);

                        // Collect domains (fresh per controller)
                        if (!_.isEmpty(controller.domainName)) {
                        controllerDomains.push(controller.domainName);
                        }
                        if (!_.isEmpty(controller.publicDomainName)) {
                        controllerDomains.push(controller.publicDomainName);
                        }
                        if (!_.isEmpty(controller.alternateDomainName)) {
                        controllerDomains.push(controller.alternateDomainName);
                        }
                        if (!_.isEmpty(controller.alternatePublicDomainName)) {
                        controllerDomains.push(controller.alternatePublicDomainName);
                        }

                        // Add this controller as its own row
                        this.items.push({
                        type: 'Network Controller',
                        ips: controllerIps,
                        domainNames: controllerDomains,
                        port: portStrings,
                        });
                    }

            }
        )

        this.getEdgeRouters();
    }

    close() {
        this.dialogRef.close();
    }

    clickToCopy(value) {
        navigator.clipboard.writeText(value);
        this.growlerService.show(
            new GrowlerData('success', 'Success', 'Info Copied', 'The firewall info has been copied to your clipboard')
        );
    }


    csv_export() {
    if (!this.items || this.items.length === 0) {
        console.warn('No data to export.');
        return;
    }

    const data = [];
    const columns = [];

    // Build header from keys
    const header = {};
    for (const column of Object.keys(this.items[0])) {
        header[column] = column.toUpperCase();
        columns.push(column);
    }
    data.push(header);

    // Construct each row
    for (const item of this.items) {
        const row = {};

        for (const column of columns) {
        if (item[column] === undefined) {
            row[column] = '';
        } else {
            switch (column) {
            case 'version number':
                row[column] = this.majorVersionNumber;
                break;

            case 'type':
                row[column] = item.type;
                break;

            case 'ips':
                row[column] = Array.isArray(item[column])
                ? item[column].filter(Boolean).join('; ')
                : item[column];
                break;

            case 'domainNames':
                row[column] = Array.isArray(item[column])
                ? item[column].filter(Boolean).join('; ')
                : item[column];
                break;

            case 'port':
                row[column] = Array.isArray(item[column])
                ? item[column].join('; ')
                : item[column];
                break;

            default:
                row[column] = item[column];
            }
        }
        }

        data.push(row);
    }

    const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: false,
        useBom: true,
    };

    new AngularCsv(data, 'NetFoundry_IP_Whitelist', options);
    }


    // getEdgeRouters() {
    //     this.edgeRouterService.getEdgeRouterPage(this.getOptions()).then((edgeRouters) => {
    //         const filteredEdgeRouters = edgeRouters.filter((edgeRouter) => edgeRouter.provider !== 'CUSTOMER')
    //         const edgeRouterIps = [];
    //         const domainNames = [];
    //         const portStrings = []

    //         for (const edgeRouter of filteredEdgeRouters) {
    //             if(semver.lt(this.networkModel.productVersion, '7.3.94')) {
    //                 portStrings.push('80/443')
    //             } else {
    //                 portStrings.push('443')
    //             }
    //             if (edgeRouter.hostId) {
    //                 this.hostService.getHost(edgeRouter.hostId).then((host) => {
    //                     if (!_.isEmpty(host)) {
    //                         if (!_.isEmpty(host.ipAddress)) {
    //                             edgeRouterIps.push(host.ipAddress);
    //                         }
    //                         if (!_.isEmpty(edgeRouter.domainName)) {
    //                             domainNames.push(edgeRouter.domainName);
    //                         }
    //                         if(!_.isEmpty(edgeRouter.publicDomainName)) {
    //                             domainNames.push(edgeRouter.publicDomainName);
    //                         }
    //                         if(!_.isEmpty(edgeRouter.alternateDomainName)) {
    //                             domainNames.push(edgeRouter.alternateDomainName);
    //                         }
    //                     }
    //                 });
    //             }
    //         }

    //         this.items.push({
    //             type: 'Hosted Edge Routers',
    //             ips: edgeRouterIps,
    //             domainNames: domainNames,
    //             port: portStrings,
    //         });
    //     });
    // }

    getEdgeRouters() {
    this.edgeRouterService.getEdgeRouterPage(this.getOptions()).then((edgeRouters) => {
        const filteredEdgeRouters = edgeRouters.filter((edgeRouter) => edgeRouter.provider !== 'CUSTOMER');

        const productVersion = this.networkModel.productVersion ?? '';
        const zitiMajor = parseInt(productVersion.split('.')[0], 10);
        // Only the Ziti 7.x track below 7.3.94 ever listed port 80; the Ziti 2.x
        // successor track (productVersion 2.x.x) and Ziti 7.3.94+ both ship 443 only.
        const isLegacyZitiPort = zitiMajor === 7 && semver.lt(productVersion, '7.3.94');
        const portString = isLegacyZitiPort ? '80/443' : '443';
        for (const edgeRouter of filteredEdgeRouters) {
            const domainNames: string[] = [];

            // Collect domain names from the edge router itself
            if (!_.isEmpty(edgeRouter.domainName)) {
                domainNames.push(edgeRouter.domainName);
            }
            if (!_.isEmpty(edgeRouter.publicDomainName)) {
                domainNames.push(edgeRouter.publicDomainName);
            }
            if (!_.isEmpty(edgeRouter.alternateDomainName)) {
                domainNames.push(edgeRouter.alternateDomainName);
            }

            if (edgeRouter.hostId) {
                this.hostService.getHost(edgeRouter.hostId).then((host) => {
                    if (!_.isEmpty(host)) {
                        const ip = host.ipAddress || '';

                        // Push one item per router
                        this.items.push({
                            type: 'Hosted Edge Router',
                            ips: [ip],
                            domainNames,
                            port: [portString],
                        });
                    }
                });
            } else {
                this.items.push({
                    type: 'Hosted Edge Router',
                    ips: [''],
                    domainNames,
                    port: [portString],
                });
            }
        }
    });
}



    private getOptions() {
        const options: PagedGetOption = {
            params: { 
                networkId: this.networkModel.id,
                embed: 'all',
             },

        };
        return options;
    }
}
